import { roundNumber } from './helpers';

export const calculationTypes = {
    KG: 1,
    ARROBA: 2,
    VALUE: 3,
};

export const getGeneralCalculationType = (typeId) => {
    const typeMapping = {
        1: calculationTypes.KG,
        2: calculationTypes.ARROBA,
        3: calculationTypes.VALUE,
        4: calculationTypes.VALUE,
    };
    return typeMapping[typeId];
}

export const calculateBovineTotalValue = ({ calculationTypeId, weight, value, arrobaWeight }) => {
    if (calculationTypeId === calculationTypes.KG) {
        return roundNumber(weight * value);
    }
    if (calculationTypeId === calculationTypes.ARROBA && weight && arrobaWeight && value) {
        return roundNumber((weight / arrobaWeight) * value);
    }
    if (calculationTypeId === calculationTypes.VALUE) {
        return value;
    }
    return 0;
}
